import { createModelStore } from '@/shared/stores/create-model-store'
import { model4InitialModel } from './initial-state'
import { model4DimensionHandlers } from './dimensions'

export const useModel4Store = createModelStore({
  initialModel: model4InitialModel,
  dimensionHandlers: model4DimensionHandlers,
})
